import config from "./config";
export const amplifyConfig = {
  Auth: {
    Cognito: {
      identityPoolId: config.AWS_COGNITO_IDENTITY_POOL_ID,
      region: config.AWS_REGION,
      userPoolId: config.AWS_COGNITO_USER_POOL_ID,
      userPoolClientId: config.AWS_COGNITO_CLIENT_ID, // Renamed from userPoolWebClientId
    }
  },
  API: {
    REST: {
      [config.API_NAME]: {
        endpoint: config.API_ENDPOINT,
        region: config.AWS_REGION,
      }
    }
  },
  Storage: {
    S3: {
      bucket: config.PORTAL_BUCKET,
      region: config.AWS_REGION,
    }
  }
};